import React, {useCallback} from 'react';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import EmptyRow from '../../../components/Simple/EmptyRow';
import {SMCSelect, SMCOption} from '../../../components/Simple/SMCSelect';
import {RoleRuleSchema} from '../../../api/DBSchema/Role';
import RowLayout from '../../../components/Layouts/RowLayout';
import ColumnLayout from '../../../components/Layouts/ColumnLayout';
import {SMCCheckbox, SMCCheckboxGroup} from '../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function RoleRuleEditorStepOne({
    onCancel,
    onNext,
    onBack,
    onFinish,
    object,
    setObjectValue,
}) {
    const { t } = useTranslation();

    const type    = object[RoleRuleSchema.type];
    const actions = object[RoleRuleSchema.actions];

    const typeValues = RoleRuleSchema.typeValues;
    const actionsValues = RoleRuleSchema.actionsValues;

    const handleNext = useCallback(() => {
        if (!actions || !actions.length) {
            alert(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_ARRAY_MIN', [0, t('SMP.ROLES.ROLE_RULE_WIZ.OPERATIONS'), 1]));
        } else {
            onNext();
        }
    }, [actions, onNext, t]);

    return (
        <>
        <SMCModalBody>
            <SMCLabel bold fontSize="15px">{t('SMP.ROLES.ROLE_RULE_WIZ.RULE_TYPE')}</SMCLabel>
            <SMCLabel>{t('SMP.ROLES.ROLE_RULE_WIZ.LINE1')}</SMCLabel>
            
            <EmptyRow />
            
            <SMCSelect
                value={type}
                onChange={e => setObjectValue(RoleRuleSchema.type, e.target.value)}
                label={t('SMP.ROLES.ROLE_RULE_WIZ.PERMISSION')}
            >
                <SMCOption value={typeValues.ALLOW}>{t('SMP.ROLES.ROLE_RULE_WIZ.PERMISSION.ALLOW')}</SMCOption>
                <SMCOption value={typeValues.BLOCK}>{t('SMP.ROLES.ROLE_RULE_WIZ.PERMISSION.BLOCK')}</SMCOption>
            </SMCSelect>
            <RowLayout>
                <SMCLabel useContextWidth>{t('SMP.ROLES.ROLE_RULE_WIZ.OPERATIONS')}</SMCLabel>
                <ColumnLayout>
                    <SMCCheckboxGroup
                        checkedValues={actions}
                        setCheckedValues={val => setObjectValue(RoleRuleSchema.actions, val)}
                    >
                        <SMCCheckbox value={actionsValues.READ} label={t('SMP_ROLES_ROLE_RULE_WIZ_RULE_TYPE_READ')} />
                        <SMCCheckbox value={actionsValues.MODIFY} label={t('SMP_ROLES_ROLE_RULE_WIZ_RULE_TYPE_MODIFY')} />
                        <SMCCheckbox value={actionsValues.CREATE} label={t('SMP_ROLES_ROLE_RULE_WIZ_RULE_TYPE_CREATE')} />
                        <SMCCheckbox value={actionsValues.DELETE} label={t('SMP_ROLES_ROLE_RULE_WIZ_RULE_TYPE_DELETE')} />
                    </SMCCheckboxGroup>
                </ColumnLayout>
            </RowLayout>
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={handleNext}>
                {t('SMC_GEN_WIZNEXT')}
                <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    )
}

export default RoleRuleEditorStepOne;